import React from 'react'
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'

const Experience = () => {
  return (
    <section id='experience'><h5>What Skills I have</h5>
    <h2>Experience</h2>
    <div className='container experience__container'>
      <div className='experience__frontend'>
        <h3>Programming</h3>
        <div className='experience__content'>
          <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>ReactJs</h4>
            </div>
          </article>
           <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <h4>AngularJs</h4>
          </article> 
          <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>Java</h4>
            </div>
          </article> 
          <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
               <h4>JavaScript</h4>
            </div>
          </article>
           <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>Python</h4>
            </div>
          </article>
           <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>C</h4>
            </div>
          </article>
        </div>
      </div>

         <div className='experience__backend'>
        <h3>Development Tools</h3>
        <div className='experience__content'>
           <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>HTML | CSS | SCSS</h4>
            </div>
          </article>
          <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>VS Code</h4>
            </div>
          </article>
           <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <h4>Responsive Websites</h4>
          </article> 

          <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
               <h4>Git</h4>
            </div>
          </article>
           <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>RESTful APIs</h4>
            </div>
          </article>
           <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
            <div>
              <h4>Command Line</h4>
            </div>
          </article>
        </div>
      </div>
    </div>
    </section>
  )
}

export default Experience